import { Form, Input, Modal, Switch } from 'antd';

import type { ModelClientField } from '@app/api/ClientFields';
import { generateSpanWithDataTestId } from '@app/shared/utils';

import type { ClientFieldFormValues } from '../../types';
import type { FormInstance } from 'antd';
import type { FC } from 'react';

// Field names are short labels; the 5000-char limit from the story applies to
// per-client field VALUES (a separate task), not to the definition name here.
const NAME_MAX_LENGTH = 255;

interface ClientFieldModalProps {
  isOpen: boolean;
  editingField: ModelClientField | null;
  form: FormInstance<ClientFieldFormValues>;
  isSubmitting: boolean;
  /** Идёт дочитывание актуального состояния поля перед редактированием. */
  isLoading?: boolean;
  onSubmit: () => void;
  onCancel: () => void;
}

export const ClientFieldModal: FC<ClientFieldModalProps> = ({
  isOpen,
  editingField,
  form,
  isSubmitting,
  isLoading = false,
  onSubmit,
  onCancel,
}) => {
  const isEditing = editingField !== null;

  return (
    <Modal
      title={generateSpanWithDataTestId(
        isEditing ? 'Редактирование поля' : 'Новое поле',
        'client-field-modal-title'
      )}
      open={isOpen}
      onOk={onSubmit}
      onCancel={onCancel}
      okText={isEditing ? 'Сохранить' : 'Создать'}
      cancelText="Отмена"
      confirmLoading={isSubmitting || isLoading}
      okButtonProps={{
        'data-testid': 'client-field-submit',
        disabled: isLoading,
      }}
      destroyOnHidden
    >
      <Form<ClientFieldFormValues>
        form={form}
        layout="vertical"
        initialValues={{ Name: '', IsDeleted: false, IsImportant: false }}
        onFinish={onSubmit}
      >
        <Form.Item
          name="Name"
          label="Название поля"
          rules={[
            {
              required: true,
              whitespace: true,
              message: 'Введите название поля',
            },
          ]}
        >
          <Input
            maxLength={NAME_MAX_LENGTH}
            placeholder="Например, Источник клиента"
            data-testid="client-field-name"
          />
        </Form.Item>
        <Form.Item
          name="IsImportant"
          label="Важное"
          valuePropName="checked"
          tooltip="Важные поля показываются в окне записи и в карточке лида"
        >
          <Switch data-testid="client-field-important" />
        </Form.Item>
        {isEditing && (
          <Form.Item name="IsDeleted" label="В архиве" valuePropName="checked">
            <Switch data-testid="client-field-archived" />
          </Form.Item>
        )}
      </Form>
    </Modal>
  );
};
